import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DefaultService } from 'src/app/core/framework/default-service';
import { DefaultFilter, DefaultServiceInterface } from 'src/app/core/framework/default-service.interface';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { ListaResultset } from 'src/app/core/list/lista-resultset.interface';
import { QuestaoParser } from '../action-controllers/controlador-de-persistencia/questao-parser';
import { Questao } from './model/questao.model';



@Injectable({
  providedIn: 'root'
})
export class QuestaoService extends DefaultService<Questao> {

  static URL = '/api/questionario/v1/questoes';

  constructor(
    public httpClient: HttpClient,
    public errorHandlerService: ErrorHandlerService
  ) {
    super(
      httpClient,
      errorHandlerService,
      QuestaoService.URL
    );
  }

  buscaInteligente(texto: string, defaultFilter: DefaultFilter): Observable<ListaResultset<Questao[]>> {
    const params = DefaultServiceInterface.converterFiltroParaHttpParam(defaultFilter);
    return this.httpClient.get<ListaResultset<Questao[]>>(`${QuestaoService.URL}/buscaInteligente`, {params})
                .pipe(
                  catchError ( err => throwError(this.errorHandlerService.handle(err)) )
                );
  }

  ordenadoPorUso(nome: string, defaultFilter: DefaultFilter): Observable<ListaResultset<Questao[]>> {
    const params = DefaultServiceInterface.converterFiltroParaHttpParam(defaultFilter);
    return this.httpClient.get<ListaResultset<Questao[]>>(`${QuestaoService.URL}/ordenadoPorUso`, {params})
    .pipe(
      catchError ( err => throwError(this.errorHandlerService.handle(err)) )
    );
  }

  criarOuAtualizarEVincularAoQuestionario(idQuestionario: number, questao: Questao): Observable<Questao> {
    const _questao = QuestaoParser.limparQuestao(questao);

    return this.httpClient.post<Questao>(`${QuestaoService.URL}/${idQuestionario}/criarOuAtualizarEVincularAoQuestionario`, _questao, this.httpOptions)
                          .pipe(
                            catchError((err: any) => throwError(this.errorHandlerService.handle(err)))
                          );
  }
}
